import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";

export const Root = styled(Container)(({ theme }) => ({
  marginTop: 48,
  marginBottom: 48,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 39,
    marginBottom: 21,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 60,
    marginBottom: 60,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 29,
  [theme.breakpoints.up("mobile")]: {
    marginBottom: 27,
  },
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 80,
  },
}));

export const Info = styled(Typography)({
  padding: 0,
});
